import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useState } from 'react'
import ECharts from '~/components/echarts'
import {
  azureDatabaseCostAnalysisChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureDatabaseReservationSankeyChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureDatabaseSkuCurrentChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureDatabaseSkuOptimizedChartOrganizationOptimizerAzureMasterOptimizationsPath,
} from '~/routes'

export default function DatabaseOptimization({ organizationId, masterOptimizationId, masterOptimization }) {
  const [activeTab, setActiveTab] = useState('cost-analysis')

  const getDatabaseCostAnalysisChartUrl = (orgId) =>
    azureDatabaseCostAnalysisChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  const getDatabaseSkuCurrentChartUrl = (orgId) =>
    azureDatabaseSkuCurrentChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  const getDatabaseSkuOptimizedChartUrl = (orgId) =>
    azureDatabaseSkuOptimizedChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  const getDatabaseReservationSankeyChartUrl = (orgId) =>
    azureDatabaseReservationSankeyChartOrganizationOptimizerAzureMasterOptimizationsPath({ organization_id: orgId })

  if (!masterOptimization) {
    return null
  }

  const handleTabChange = (tabId) => {
    setActiveTab(tabId)
  }

  return (
    <div className='row mb-4'>
      <div className='col-12'>
        <div className='card'>
          <div className='card-header'>
            <div className='d-flex justify-content-between align-items-center'>
              <h5 className='card-title mb-0'>
                <Trans>Azure Database Optimization</Trans>
              </h5>
            </div>
          </div>
          <div className='card-body'>
            <ul className='nav nav-tabs'>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'cost-analysis' ? 'active' : ''}`}
                  onClick={() => handleTabChange('cost-analysis')}
                  type='button'
                  role='tab'
                >
                  <Trans>Cost Analysis</Trans>
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'db-sku' ? 'active' : ''}`}
                  onClick={() => handleTabChange('db-sku')}
                  type='button'
                  role='tab'
                >
                  <Trans>DB & Pool SKU Charts</Trans>
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'reservation-sankey' ? 'active' : ''}`}
                  onClick={() => handleTabChange('reservation-sankey')}
                  type='button'
                  role='tab'
                >
                  <Trans>Reservation Chart</Trans>
                </button>
              </li>
            </ul>

            <div className='mt-3'>
              {activeTab === 'cost-analysis' && (
                <ECharts
                  title={t`Daily Cost Comparison`}
                  chartInfoTitle='azure_db_optimization_daily_cost_comparison'
                  url={getDatabaseCostAnalysisChartUrl(organizationId)}
                  params={{ master_optimization_id: masterOptimizationId }}
                />
              )}

              {activeTab === 'db-sku' && (
                <div className='row'>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Current DB & Pool SKUs`}
                      chartInfoTitle='azure_db_current_db_and_pool_skus'
                      url={getDatabaseSkuCurrentChartUrl(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Optimized DB & Pool SKUs`}
                      chartInfoTitle='azure_db_optimized_db_and_pool_skus'
                      url={getDatabaseSkuOptimizedChartUrl(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                </div>
              )}

              {activeTab === 'reservation-sankey' && (
                <ECharts
                  title={t`Database Reservation Management`}
                  chartInfoTitle='azure_db_reservation_management'
                  url={getDatabaseReservationSankeyChartUrl(organizationId)}
                  params={{ master_optimization_id: masterOptimizationId }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
